import React from 'react';

const MAX_PHONE_DIGITS = 10;

export const formatPhoneNumber = value => {
  const str = String(value ?? '').trimStart();
  const hasPlusOne = str.startsWith('+1');
  const digits = (hasPlusOne ? str.slice(2) : str).replace(/\D/g, '').slice(0, MAX_PHONE_DIGITS);

  if (!digits) {
    if (hasPlusOne) return '+1';
    if (str.startsWith('+')) return '+';
    return '';
  }

  const prefix = hasPlusOne ? '+1 ' : '';
  if (digits.length <= 3) return `${prefix}(${digits}`;
  if (digits.length <= 6) return `${prefix}(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `${prefix}(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const FormattedPhoneField = ({
  value = '',
  onChange,
  className = 'form-control form-control-sm',
  placeholder = '(123) 456-7890',
  ...rest
}) => {
  const handleChange = event => {
    const formatted = formatPhoneNumber(event.target.value);
    onChange?.({ ...event, target: { ...event.target, value: formatted } });
  };

  return (
    <input
      type="tel"
      className={className}
      value={formatPhoneNumber(value)}
      onChange={handleChange}
      placeholder={placeholder}
      inputMode="tel"
      autoComplete="tel"
      {...rest}
    />
  );
};

export default FormattedPhoneField;
